import { useKeycloak } from "../src/useKeycloak";

/**
 * useUserRole
 * @returns {{role: string, hasElevatedRights: boolean}}
 */
const useUserRole = () => {
	const { tokenParsed } = useKeycloak();

	let role = "operator";
	if (tokenParsed?.resource_access?.youtello?.roles?.includes("superadmin")) {
		role = "superadmin";
	}
	else if (tokenParsed.resource_access.youtello.roles.includes("operatorphonero")) {
		role = "operatorphonero";
	}
	else if (tokenParsed.resource_access.youtello.roles.includes("operatortelia")) {
		role = "operatortelia";
	}
	else if (tokenParsed?.resource_access?.youtello?.roles?.includes("orgadmin")) {
		role = "orgadmin";
	}

	const hasElevatedRights = role === "superadmin" || role === "orgadmin" || role === "operatorphonero" || role === "operatortelia";

	const allRoles = tokenParsed?.resource_access?.youtello?.roles;

	return { role, hasElevatedRights, allRoles };
};

export default useUserRole;
